import { heroPortraitUrl } from "~/utils/heroPortraitUrl"
import type { DogPortraitInfo } from "~/api/auth"

interface AskDynamoDogPillProps {
  dogName: string
  archetypeLabel: string
  archetypeIcon: string | null
  portrait?: DogPortraitInfo | null
}

export function AskDynamoDogPill({
  dogName,
  archetypeLabel,
  archetypeIcon,
  portrait = null,
}: AskDynamoDogPillProps) {
  const portraitUrl = heroPortraitUrl(archetypeIcon, portrait)

  return (
    <div className="mt-4 flex items-center gap-3 rounded-full border border-[var(--color-ask-dynamo)]/15 bg-white/80 px-3 py-2 shadow-sm">
      {portraitUrl ? (
        <img
          src={portraitUrl}
          alt=""
          data-testid="ask-dynamo-dog-pill-image"
          className="h-10 w-10 shrink-0 rounded-full object-cover"
        />
      ) : (
        <span
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[var(--color-ask-dynamo-surface)] text-sm font-semibold text-[var(--color-ask-dynamo)]"
          aria-hidden
        >
          {dogName.charAt(0)}
        </span>
      )}
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-[var(--color-text-primary)]">{dogName}</p>
        <p className="truncate text-xs text-[var(--color-ask-dynamo-muted)]">{archetypeLabel}</p>
      </div>
    </div>
  )
}
